import { apiSlice } from "../../app/api/apiSlice";
import { ApiResponse, ReviewObj } from "../../shared/types";

type CreateReviewData = {
    review: string;
    rating: number;
    tour: string;
    user: string;
};

type UpdateReviewData = {
    reviewId: string;
    rating: number;
    review: string;
};

export const reviewsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReviews: builder.query<ApiResponse<ReviewObj[]>, string>({
            query: (id: string) => ({ url: `/api/v1/tours/${id}/reviews` }),
            keepUnusedDataFor: 10,
            providesTags: [{ type: "Tour" as const, id: "LIST" }],
        }),
        createReview: builder.mutation<ApiResponse<ReviewObj>, CreateReviewData>({
            query: (reviewData) => ({
                url: `/api/v1/reviews`,
                method: "POST",
                body: { ...reviewData },
            }),
            invalidatesTags: [{ type: "Tour", id: "LIST" }],
        }),
        updateReview: builder.mutation<ApiResponse<ReviewObj>, UpdateReviewData>({
            query: (reviewData) => ({
                url: `/api/v1/reviews/${reviewData.reviewId}`,
                method: "PATCH",
                body: { ...reviewData },
            }),
            invalidatesTags: [{ type: "Tour", id: "LIST" }],
        }),
        deleteReview: builder.mutation<unknown, string>({
            query: (id: string) => ({
                url: `/api/v1/reviews/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: [{ type: "Tour", id: "LIST" }],
        }),
    }),
})

export const {
    useGetReviewsQuery,
    useCreateReviewMutation,
    useUpdateReviewMutation,
    useDeleteReviewMutation,
} = reviewsApiSlice
